<div class="searchBar">
  <label class="form-label" for="searchBar-input" translate>label.filtrer</label>
  <input type="text" id="searchBar-input" (ngModelChange)="searchStringUpdate.next($event)" [(ngModel)]="searchStringInput"
    placeholder="{{'label.filtre'|translate}}">
</div>

